import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'What software do I need?',
    a: 'Adobe Photoshop is recommended. Any PSD-compatible editor will also work. Just open the file, edit, and export.',
  },
  {
    q: 'Do I need design skills?',
    a: 'Not at all. The templates are ready-made — just change the text, swap the photos, adjust colors if you want, and you\'re done.',
  },
  {
    q: 'How do I get the templates after payment?',
    a: 'Immediately after payment, you\'ll see a download link on screen. We also send it to your email so you never lose access.',
  },
  {
    q: 'Can I use these for my business or clients?',
    a: 'Yes! All templates come with a commercial-use license. Use them for your own brand, client work, or social media pages.',
  },
  {
    q: 'What currencies can I pay in?',
    a: 'We accept 14 currencies including Nigerian Naira, Ghanaian Cedi, Kenyan Shilling, South African Rand, US Dollar, British Pound, Euro, and more.',
  },
  {
    q: 'Can I get a refund?',
    a: 'Since the templates are delivered digitally via instant download, we do not offer refunds. Please review the product details before purchasing.',
  },
];

const styles = {
  section: {
    padding: '100px 20px',
    background: '#fafafa',
  },
  container: {
    maxWidth: '700px',
    margin: '0 auto',
  },
  heading: {
    textAlign: 'center',
    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
    fontWeight: 800,
    color: '#0f172a',
    marginBottom: '60px',
  },
  item: {
    marginBottom: '12px',
    borderRadius: '12px',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    overflow: 'hidden',
  },
  question: {
    width: '100%',
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#0f172a',
    textAlign: 'left',
    fontFamily: 'inherit',
  },
  answer: {
    padding: '0 24px 20px',
    fontSize: '0.95rem',
    color: '#64748b',
    lineHeight: 1.7,
  },
};

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.heading}>Frequently Asked Questions</h2>
        {faqs.map((faq, index) => (
          <div key={index} style={styles.item}>
            <button
              style={styles.question}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              {faq.q}
              <motion.span
                animate={{ rotate: openIndex === index ? 180 : 0 }}
                transition={{ duration: 0.2 }}
              >
                <ChevronDown size={20} color="#94a3b8" />
              </motion.span>
            </button>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <p style={styles.answer}>{faq.a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
